module.exports = __webpack_public_path__ + "static/img/tool1.3eae5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/tool1.png
// module id = sBEZ
// module chunks = 0